module.exports = __webpack_public_path__ + "static/img/burger.371206e8.svg";